import React from 'react'

function Object() {
    return (
        <span className='cs-data-object'>Object</span>
    )
}

export { Object }